import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

type BookmarkToggleProps = {
  className?: string;
  /** What is bookmarked, so the button's name says which result it belongs to. */
  name: string;
  bookmarked: boolean;
  disabled?: boolean;
  onToggle: () => void;
};

/**
 * The bookmark on a marketplace result card: one icon in the card's header, pressed while the result
 * is bookmarked. Before #5410 it was a full-width outlined button among five others.
 *
 * The name stays the same whichever way it is pressed, and `aria-pressed` says which way it is — a
 * name that flipped to "Remove bookmark" as well would tell a screen reader the state twice and move
 * the control a Playwright or Testing Library query was holding. `describeChild` keeps the tooltip
 * from overwriting that name with its own text.
 */
export default function BookmarkToggle(props: Readonly<BookmarkToggleProps>) {
  const { className, name, bookmarked, disabled, onToggle } = props;

  return (
    <Tooltip describeChild title={bookmarked ? "Remove bookmark" : "Bookmark"}>
      <span className={className}>
        <IconButton
          aria-label={`Bookmark ${name}`}
          aria-pressed={bookmarked}
          color={bookmarked ? "primary" : "default"}
          disabled={disabled}
          onClick={onToggle}
        >
          {bookmarked ? <BookmarkIcon /> : <BookmarkBorderIcon />}
        </IconButton>
      </span>
    </Tooltip>
  );
}
